import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getArticlesByCategory } from "@/mocks/articles";
import ArticleCard from "@/components/feature/ArticleCard";

export default function CategorySection() {
  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            📂 分类吃瓜
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按你的口味，精准吃瓜不迷路</p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-2 mb-8">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="px-4 py-2 rounded-full bg-background-50 text-foreground-700 text-sm font-medium hover:bg-primary-500 hover:text-background-50 transition-all duration-300 whitespace-nowrap cursor-pointer border border-background-200"
            >
              {cat.name}
            </Link>
          ))}
        </div>

        <div className="space-y-10">
          {categories.map((cat) => {
            const catArticles = getArticlesByCategory(cat.id).slice(0, 3);
            if (catArticles.length === 0) return null;
            return (
              <div key={cat.id}>
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-bold text-foreground-950 font-heading">{cat.name}</h3>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap cursor-pointer"
                  >
                    更多 →
                  </Link>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                  {catArticles.map((article) => (
                    <ArticleCard key={article.id} article={article} />
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}